import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { playSay, stopReading } from "@/lib/readingAudio";
import { ReadingBg } from "@/pages/ReadingHome";

// The 60 frequent words of the Level 3 kit, 5 per week, tap a word to hear it.
export default function ReadingFrequent() {
  const { childId, lang } = useParams();
  const navigate = useNavigate();
  const [words, setWords] = useState([]);
  const fr = lang === "fr";
  useEffect(() => {
    api.get(`/reading/frequent-words/${lang}`).then(({ data }) => setWords(data.words)).catch(() => {});
    return () => stopReading();
  }, [lang]);
  const weeks = [];
  for (let k = 0; k < words.length; k += 5) weeks.push(words.slice(k, k + 5));
  return (
    <ReadingBg>
      <header className="max-w-5xl mx-auto px-5 pt-5 flex items-center gap-3">
        <button onClick={() => navigate(`/kid/${childId}/reading/${lang}`)} className="w-11 h-11 rounded-full bg-white border-[3px] border-slate-900 flex items-center justify-center" data-testid="frequent-back"><ArrowLeft /></button>
        <h1 className="text-2xl sm:text-3xl font-bold" data-testid="frequent-title">{fr ? "Les mots fréquents" : "Frequent words"}</h1>
      </header>
      <main className="max-w-5xl mx-auto px-5 py-6 space-y-5">
        <p className="text-slate-700">{fr ? "5 mots par semaine. Lis-les d'un coup d'œil, puis cherche-les dans le petit texte !" : "5 words a week. Read them at a glance, then find them in the little text!"}</p>
        {weeks.map((w, i) => (
          <motion.section key={i} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.03 }} className="rounded-3xl bg-white border-[3px] border-slate-900 p-4" data-testid={`frequent-week-${i + 1}`}>
            <p className="text-sm font-bold text-slate-500 mb-2">{fr ? `Semaine ${i + 1}` : `Week ${i + 1}`}</p>
            <div className="flex flex-wrap gap-2">
              {w.map((x) => <button key={x} onClick={() => playSay(x, lang)} className="rounded-2xl bg-yellow-200 border-2 border-slate-900 px-4 py-2 text-xl font-bold hover:-translate-y-0.5 transition-transform" data-testid={`frequent-word-${x}`}>{x}</button>)}
            </div>
          </motion.section>
        ))}
      </main>
    </ReadingBg>
  );
}
